export default __webpack_public_path__ + "static/media/roti-roesli-im-garte.1c177cd2.pdf";